import UPSERT_CONNECTOR_SETTING from "@/graphql/UpsertConnectorSetting.gql";

import { apolloClient } from "@/apollo.services";

export class ConnectorServices {
    static getLogo(connectorName) {
        const formattedName = ConnectorServices.formatApplicationName(connectorName);
        try {
            const imagePath = require(`@/assets/img/connectors/${formattedName}.png`);
            return imagePath;
        } catch (error) {
            console.error(`Image not found for connector: ${formattedName}`);
            return ""; // ou retournez une image par défaut
        }
    }

    static formatApplicationName(name: string): string {
        return name
            .toLowerCase()
            .replace(/ |-|'|\.|\(|\)|&/g, "")
            .replace(/é|è|ê|ë/g, "e")
            .replace(/à|â|á|ä/g, "a")
            .replace(/î|ï|í/g, "i")
            .replace(/ô|ö|ó/g, "o")
            .replace(/û|ü|ú/g, "u")
            .replace(/ç|č/g, "c")
            .replace(/ñ/g, "n")
            .replace(/æ/g, "ae")
            .replace(/œ/g, "oe")
            .replace(/ß/g, "ss")
            .replace(/š/g, "s")
            .replace(/ž/g, "z")
            .replace(/ø/g, "o")
            .replace(/ł/g, "l")
            .replace(/:/g, "");
    }

    static async upsertSettingHelper(configValue, companyId) {
        debugger;
        const upsertConfig = await apolloClient.mutate({
            mutation: UPSERT_CONNECTOR_SETTING,
            variables: {
                id: configValue.id,
                name: configValue.name,
                company: companyId,
                origin: configValue.origin,
                application: configValue.application,
                importMode: configValue.importMode,
                importDate: configValue.date,
                data: configValue.data,
                status: configValue.status,
                customerId: configValue.customerId,
                currentError: configValue.currentError,
                lastImportDate: configValue.lastImportDate,
            },
        });
        return upsertConfig;
    }

    static getType(type: string): string {
        switch (type) {
            case "INVOICE":
                return "Facture";
            case "E-COMMERCE":
                return "E-commerce";
            case "POINT_OF_SALE":
                return "Point de vente";
            case "COLLECT":
                return "Service";
            case "INVOICING":
                return "Facturation";

            default:
                return type;
        }
    }
}
